import { render, staticRenderFns } from "./CatalogDemand.vue?vue&type=template&id=8fe18eca&scoped=true&"
import script from "./CatalogDemand.vue?vue&type=script&lang=ts&"
export * from "./CatalogDemand.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogDemand.vue?vue&type=style&index=0&id=8fe18eca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe18eca",
  null
  
)

export default component.exports